export const adminsProfileKeys = {
  all: ["admins-profile"] as const,
  details: () => [...adminsProfileKeys.all, "detail"] as const,
  detail: () => [...adminsProfileKeys.details()] as const,
};
